import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Supported languages: Chinese (zh), English (en), Spanish (es), French (fr), Russian (ru), Arabic (ar)
// Translation files are loaded from: /public/locales/{{lng}}/{{ns}}.json

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng:(localStorage.getItem('language')|| i18n.resolvedLanguage || i18n.language || 'en').split('-')[0],
    fallbackLng: 'en',
    supportedLngs: ['zh', 'en', 'es', 'fr', 'ru', 'ar'],
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

// Update <html> attributes on language change (for RTL languages like Arabic)
i18n.on('languageChanged', (lng) => {
  const html = document.documentElement;
  html.lang = lng;
  html.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

export default i18n;

